"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var AmenityList_1 = __importDefault(require("./AmenityList"));
var SectionHeader_1 = __importDefault(require("../../../SectionHeader"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BuildingProperties = function (_a) {
    var aboutBuildings = _a.aboutBuildings;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.section_header },
            react_1.default.createElement(SectionHeader_1.default, { title: t('POST_PREVIEW.BUILDING_PROPERTIES').toUpperCase() })),
        react_1.default.createElement(AmenityList_1.default, { aboutBuildings: aboutBuildings })));
};
exports.default = BuildingProperties;
